import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from '@mui/material'
import styled from 'styled-components'

export const DialogStyled = styled(Dialog)``
export const DialogTitleStyled = styled(DialogTitle)``
export const DialogContentStyled = styled(DialogContent)``
export const DialogActionsStyled = styled(DialogActions)``

export const ContainerLista = styled.ul`
  list-style: none;
`
export const ItemLista = styled.li`
  padding: 1%;
  font-size: 1rem;
  font-weight: 600;
  font-family: Arial, Helvetica, sans-serif;
  cursor: pointer;
  transition: 1s;
  :hover {
    background: #ffe4a5;
    transform: scale(1.05);
  }
`
